const DescargaRecomendada = ({ selectedYear, tipo = "completo" }) => {
    if (parseInt(selectedYear) < 2025) return null;

    const mostrarUnificado = tipo === "completo" || tipo === "abajo";
    const mostrarIndividuales = tipo === "completo" || tipo === "arriba";

    return (
        <div className="alert alert-info mt-3">
            {mostrarIndividuales && (
                <>
                    <h5 className="mb-2">¿Qué archivo descargar?</h5>
                    <p className="mb-2">
                        A partir del periodo 2025-1, el Instituto ofrece dos
                        opciones para consultar los APU, según la versión de
                        Excel que tenga instalada:
                    </p>
                    <ul className="mb-2">
                        <li>
                            <strong>Archivos individuales</strong> (Para
                            versiones anteriores a Microsoft 365 versión 2304 de
                            Excel): si su versión de Excel no permite ver mapas
                            o imágenes, utilice la opción tradicional para
                            descargar archivos por provincia, departamento o
                            país.
                        </li>
                    </ul>
                </>
            )}
            {mostrarUnificado && (
                <>
                    <h5 className="mb-2">
                        Territorio APU "Los precios del territorio nacional, en
                        un solo lugar"
                    </h5>
                    <ul className="mb-2">
                        <li>
                            <strong>Botón "Territorio APU"</strong> (si tiene
                            Microsoft 365 versión 2304 o superior): descargue un
                            solo archivo Excel con la información de las 140
                            provincias. Desde la pestaña <em>Portada</em> podrá
                            seleccionar la provincia de interés, visualizar el
                            mapa y consultar automáticamente los datos.
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
};

export default DescargaRecomendada;
